import { render, staticRenderFns } from "./SharingDetailsTab.vue?vue&type=template&id=c672ed08&scoped=true"
import script from "./SharingDetailsTab.vue?vue&type=script&lang=js"
export * from "./SharingDetailsTab.vue?vue&type=script&lang=js"
import style0 from "./SharingDetailsTab.vue?vue&type=style&index=0&id=c672ed08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c672ed08",
  null
  
)

export default component.exports